import React from 'react';
import { CheckCircle2, Star, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-6 pb-8 px-4 md:pt-20 md:pb-24 overflow-hidden bg-gradient-to-b from-brand-50 to-white" data-id="element-162">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center z-10" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-block bg-brand-100 text-brand-800 font-bold px-2.5 py-0.5 md:px-3 md:py-1 rounded-full text-[10px] md:text-sm mb-3 md:mb-6 border border-brand-200" data-id="element-164">
          PROFESORADO RESUELTO™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-2xl md:text-5xl lg:text-6xl font-black text-brand-950 leading-tight mb-3 md:mb-8 tracking-tight" data-id="element-165">
          Todo tu año <br className="hidden md:block" data-id="element-166" />
          <span className="text-brand-600" data-id="element-167">académico resuelto</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="relative w-[75%] md:w-[70%] mb-3 md:mb-8" data-id="element-168">
          <div className="absolute inset-0 bg-brand-200 rounded-full blur-3xl opacity-30 animate-pulse" data-id="element-169"></div>
          <img src="https://cdn.magicpatterns.com/uploads/73AfRXNZrLSu6Nr3FHc9ot/mockuppng-Photoroom.png" alt="Profesorado Resuelto Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-170" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-sm md:text-xl text-gray-700 font-medium mb-3 md:mb-6 max-w-2xl leading-snug" data-id="element-171">
          Todo tu Profesorado de Educación Física resuelto en un fin de semana.
          Parciales, prácticas, planificación, anatomía y mucho más.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-4 md:mb-8" data-id="element-172">
          {['PDF digital', 'Acceso inmediato', 'Todos los años', 'Garantía 7 días'].map((prop, i) => <div key={i} className="flex items-center gap-1 text-[10px] md:text-sm font-semibold text-brand-800 bg-white px-2 py-0.5 md:px-3 md:py-1.5 rounded-md shadow-sm border border-gray-100" data-id="element-173">
              <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-brand-600" data-id="element-174" />
              {prop}
            </div>)}
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} onClick={scrollToPricing} className="w-full sm:w-auto bg-accent-500 hover:bg-accent-600 text-white font-black text-sm md:text-xl py-3 px-5 md:py-4 md:px-8 rounded-xl shadow-[0_8px_30px_rgb(239,68,68,0.3)] transition-transform hover:scale-105 active:scale-95 flex items-center justify-center gap-2" data-id="element-175">
          💥 QUIERO MI PROFESORADO RESUELTO
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="mt-3 md:mt-6 flex flex-col items-center gap-2 md:gap-4 w-full" data-id="element-176">
          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 md:gap-x-6 md:gap-y-2 text-[10px] md:text-sm font-semibold text-gray-700" data-id="element-177">
            <div className="flex items-center gap-1" data-id="element-178">
              <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-179" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-180">
              <span className="text-brand-600 font-black" data-id="element-181">+500</span>{' '}
              estudiantes
            </div>
            <div className="flex items-center gap-1" data-id="element-182">
              <Star className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-yellow-400" data-id="element-183" />
              4.9/5
            </div>
            <div className="flex items-center gap-1" data-id="element-184">🇦🇷 Todo el país</div>
          </div>
        </motion.div>
      </div>
    </section>;
}